import { defineMessages } from "react-intl";

const messages = defineMessages({
  searchLabel: {
    id: "search.label",
    defaultMessage: "Search",
    description: "Label search button",
  },
  switchLabel: {
    id: "search.switch.label",
    defaultMessage: "switch",
    description:
      "The label for a button that switches the origin and destination",
  },
  originIconLabel: {
    id: "search.origin.icon.label",
    defaultMessage: "Origin icon",
    description: "Label for the origin icon in the search bar",
  },
  destinationIconLabel: {
    id: "search.destination.icon.label",
    defaultMessage: "Destination icon",
    description: "Label for the destination icon in the search bar",
  },
  returnLabel: {
    id: "search.return.label",
    description: "The return date label",
    defaultMessage: "Return",
  },
  departureLabel: {
    id: "search.departure.label",
    description: "The departure date label",
    defaultMessage: "Depart",
  },
  promptEndText: {
    id: "search.promptEndText",
    description: "The prompt to select a return date",
    defaultMessage: "+ Add return",
  },
  promptBeginText: {
    id: "search.promptBeginText",
    description: "The prompt to select a departure date",
    defaultMessage: "Add departure",
  },
});

export default messages;
